export const omnichannelContent = {
  stamp: "OMNICHANNEL CAPTURE • 1 BRAIN",
  title: "Intercept Leads Anywhere They Reach Out.",
  body:
    "Whether a homeowner submits a website form, sends an SMS, or messages via Facebook/Instagram Ads — the assistant intercepts in 26 seconds and routes the booked inspection straight to your CRM.",
  channels:
    "[ Web Forms • GoHighLevel • SMS • Facebook Messenger • Instagram DM • Email ]",
}
